// useAboutOnce - Affiche le modal "Qui sommes-nous ?" automatiquement
// 1 fois par utilisateur (clé localStorage). Permet aussi un trigger manuel.

import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY_PREFIX = "arteknos_about_seen_v1_";

export default function useAboutOnce(userId) {
  const [open, setOpen] = useState(false);

  // Auto-open au mount si user présent et non vu
  useEffect(() => {
    if (!userId) return;
    try {
      const key = STORAGE_KEY_PREFIX + userId;
      if (!localStorage.getItem(key)) {
        // Petit délai pour ne pas bloquer le rendu initial
        const t = setTimeout(() => setOpen(true), 600);
        return () => clearTimeout(t);
      }
    } catch (e) {
      console.debug("[useAboutOnce] localStorage err:", e);
    }
    return undefined;
  }, [userId]);

  const handleClose = useCallback(() => {
    setOpen(false);
    if (userId) {
      try {
        localStorage.setItem(STORAGE_KEY_PREFIX + userId, "1");
      } catch (e) {
        console.debug("[useAboutOnce] persist err:", e);
      }
    }
  }, [userId]);

  const openManually = useCallback(() => setOpen(true), []);

  return { open, close: handleClose, openManually };
}
